<template>
  
    <div id="main">

        <main-video></main-video>

        <div class="container-fluid"> 

            <div class="row flex-column-reverse flex-sm-row" style="margin: auto">
                           
                <div class="col-sm-6 order-sm-1 main__container">

                    <main-map></main-map>

                </div>

                <div class="col-sm-6 order-sm-2 main__container">
                   
                    <main-text></main-text>

                </div>

            </div> 
    
        </div>

    </div>

</template>

<script>
import MainVideo from './MainVideo.vue'
import MainText from './MainText.vue'
import MainMap from './MainMap.vue'

export default {
  components: {
    mainText: MainText,
    mainMap: MainMap,
    mainVideo: MainVideo,
  }
}
</script>

<style lang="scss" scoped>
#main {
    width: 100%;

    *:not(:last-child) {
    margin-bottom: 2rem;
  }
}

.main__container {
    width: 100%;

    display: flex;
    justify-content: center;
    align-items: flex-start;


    @media only screen and (max-width: 700px) {
        margin-top: 2rem;
        margin-bottom: 2rem;
    }
}

.container-fluid {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
}



</style>